import { Action, config, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import DecisionModule from "@/store/decision/Decision";
import ViewpointsModule from "@/store/viewpoint/viewpoint";
import _ from "lodash";
import { Choice } from "@/api/model/Choice";
import { ChoiceScore } from "@/api/model/ViewpointChoiceScore";
import { Auth } from "aws-amplify";

config.rawError = true

const name = 'properties';
if (module.hot) {
    if (store.hasModule(name)) {
        store.unregisterModule(name);
    }
}

@Module({dynamic: true, store, name: name, namespaced: true})
export default class Properties extends VuexModule {

    properties: { [id: string]: Choice } = {};
    propertiesScores: { [choiceId: string]: ChoiceScore } = {};

    @Mutation
    setProperties(choices: Choice[]) {
        this.properties = _.keyBy(choices, "id");
    }

    @Mutation
    setPropertiesScores(value: { [p: string]: ChoiceScore }) {
        this.propertiesScores = value;
    }

    get sortedScores(): ChoiceScore[] {
        return Object.values(this.propertiesScores)
            .sort((a, b) => b.score - a.score)
    }

    @Action
    async getProperties() {
        let decision = getModule(DecisionModule).decision
        let selectedViewpointId = getModule(ViewpointsModule).selectedViewpointId
        let viewpointFactors = getModule(ViewpointsModule).viewpointFactors
        let modelFactors = getModule(DecisionModule).factorResourceMap
        if (!decision || !modelFactors) return;
        let constraints = Object.values(viewpointFactors)
            //@ts-ignore
            .filter(v => v.constraint && modelFactors[v.id])
            //@ts-ignore
            .reduce((map, obj) => (map[modelFactors[obj.id].dataField] = obj.constraint, map), {});

        let choicesFuture = VIEWPOINT_API.getConstraintChoices(decision.choicesSourceId, constraints)
        let propertiesScoresFuture = await VIEWPOINT_API.getViewpointScore(decision.decisionId, 'PUBLISHED', selectedViewpointId)

        this.setProperties(await choicesFuture);
        this.setPropertiesScores((await propertiesScoresFuture).choiceScores)
    }

    @Action
    async clear() {
        this.setPropertiesScores({})
        this.setProperties([])
    }

}
